module.exports = __webpack_public_path__ + "static/media/taeil-10.jpeg";